/* eslint-disable import/no-unresolved */
import DateInput from '@components/c-date-input';
import Messages from '../../../blocks/auth/scripts/utils/Messages';

const contactUsPage = {
  init() {
    const container = document.querySelector('.wpcf7-form--contact-us');
    if (!container) return;

    const messageSource = container.closest('.contact-us__form-wrap') || container;
    const messages = new Messages(messageSource);
    const dateInputs = DateInput.initAll(container, {
      messages: {
        required: messages.getMessage('required'),
      },
    });

    const form = container.closest('form') || container;
    form.addEventListener(
      'submit',
      (e) => {
        const allValid = dateInputs.every((d) => d.validate());
        if (!allValid) {
          e.preventDefault();
        }
      },
      true,
    );

    // wpcf7reset fires after CF7 has fully reset the form (after form.reset()),
    // so IMask can safely restore the placeholder at this point
    container.addEventListener('wpcf7reset', () => {
      dateInputs.forEach((d) => d.reset());
    });
  },
};

export default contactUsPage;

contactUsPage.init();
